import clsx from "clsx";
import { FC } from "react";
import { productFacts } from "../../../model/utils";
import s from "./styles.module.sass";

const AboutProduct: FC = () => {
	return (
		<section className="marginedSection">
			<h3 className={s.title}>О проекте</h3>
			<ul className={s.productFacts}>
				{productFacts.map((fact, index) => {
					return (
						<li
							key={index}
							className={clsx(s.fact, {
								[s.primaryLight]: index > productFacts.length / 2 - 1,
							})}
						>
							<p className={s.numeration}>0{index + 1}</p>
							<p>{fact.description}</p>
						</li>
					);
				})}
			</ul>
		</section>
	);
};

export default AboutProduct;
